export abstract class ArticlesEvent {}

export class ArticlesLoad extends ArticlesEvent {}
